'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PropTypes = require('prop-types');
var React = require('react');
var ADAHelpers = require('../lib/ADAHelpers');

var GenericDropDown = function (_React$Component) {
    _inherits(GenericDropDown, _React$Component);

    function GenericDropDown() {
        var _temp, _this, _ret;

        _classCallCheck(this, GenericDropDown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            id: _this.props.id || 'dropdown-' + Math.round(Math.random() * 10000)
        }, _this.closeOpenDropdown = function () {
            var $dropdown = $('#' + _this.state.id);
            if ($dropdown.parent().hasClass('open')) {
                $dropdown.dropdown('toggle');
            }
        }, _this.handleKeyDown = function (e) {
            var parent = e.target.parentNode;
            if (e.target.className === 'dropdown-toggle') {
                e.currentTarget = e.target; // since the ADA handler uses currentTarget
                _this.props.keyDownHandler(e);
                if (e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 40) {
                    parent.querySelector('.dropdown-menu > *').focus();
                } else if (e.keyCode === 9 && e.shiftKey) {
                    _this.closeOpenDropdown();
                }
            } else if (parent.className.match(/dropdown-menu/)) {
                switch (e.keyCode) {
                    case 13: // enter
                    case 32:
                        // space
                        e.target.click();
                        document.getElementById(_this.state.id).focus();
                        break;
                    case 9:
                        //tab
                        if (!e.shiftKey && !e.target.nextSibling || e.shiftKey && !e.target.previousSibling) {
                            _this.closeOpenDropdown();
                        }
                        break;
                    case 38:
                        // up arrow
                        e.preventDefault();
                        if (e.target.previousSibling) e.target.previousSibling.focus();
                        break;
                    case 40:
                        //down arrow
                        e.preventDefault();
                        if (e.target.nextSibling) e.target.nextSibling.focus();
                        break;
                    default:
                        break;
                }
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    GenericDropDown.prototype.render = function render() {
        var dropDownClass = 'dropdown ' + this.props.customDropDownClass;
        var caretClass = this.props.customCaratClass;
        var valueID = 'dd-selected-' + this.state.id;
        var listClass = 'dropdown-menu ' + this.props.customListClass;
        return React.createElement(
            'div',
            { className: dropDownClass, onKeyDown: this.handleKeyDown },
            React.createElement(
                'div',
                _extends({
                    'aria-expanded': 'false',
                    'aria-haspopup': 'true',
                    'aria-labelledby': valueID,
                    className: 'dropdown-toggle',
                    'data-toggle': 'dropdown',
                    id: this.state.id,
                    role: 'listbox',
                    tabIndex: '0'
                }, this.props.attributes),
                React.createElement(
                    'span',
                    { id: valueID, 'aria-selected': !!this.props.selectedElement, role: 'option' },
                    this.props.selectedElement || React.createElement(
                        'span',
                        { className: 'place-holder-option' },
                        this.props.placeholder
                    )
                ),
                React.createElement('span', { className: caretClass })
            ),
            React.createElement(
                'ul',
                { className: listClass, 'aria-labelledby': this.state.id, 'aria-controls': this.state.id },
                this.props.listElements.map(function (listElement) {
                    return React.cloneElement(listElement, { tabIndex: 0 });
                })
            )
        );
    };

    return GenericDropDown;
}(React.Component);

GenericDropDown.propTypes = {
    attributes: PropTypes.shape({}),
    customCaratClass: PropTypes.string,
    customDropDownClass: PropTypes.string,
    customListClass: PropTypes.string,
    id: PropTypes.string,
    keyDownHandler: PropTypes.func,
    listElements: PropTypes.array.isRequired, //ARRAY OF LI JSX
    placeholder: PropTypes.string,
    selectedElement: PropTypes.any
};
GenericDropDown.defaultProps = {
    attributes: {},
    customCaratClass: 'genericDropDownCaret',
    customDropDownClass: '',
    customListClass: '',
    keyDownHandler: ADAHelpers.keyupHandler
};


module.exports = GenericDropDown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/GenericDropDown.js
// module id = 826
// module chunks = 0